import * as _ from 'lodash'

export const ensureGetData = (target, path, fallback = null, modReturn = res => res) =>
  _.has(target, path) && !_.isEmpty(target[path])
    ? modReturn(target[path], _)
    : _.isNull(fallback)
    ? path
    : fallback

export const htmlDecode = input => {
  var doc = new DOMParser().parseFromString(input, 'text/html')
  return doc.documentElement.textContent
}
